import {useState } from 'react';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import './SupportFaq.css';
import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
import { Link } from 'react-router-dom';


const SupportFaq = () => {

  // Expand all panels by default
  const [expanded, setExpanded] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const [showWaitlist, setShowWaitlist] = useState(false);
  // Data for each accordion
  const accordionData = [
    {
        title: "What is Rentid?",
        content: "Rentid is a host-first rental platform that gives you full control over your rental business. Unlike marketplaces, Rentid provides the software, insurance, and verification tools so you can operate independently without platform commissions or restrictions",
    },
    {
        title: "How is Rentid different from Getaround, HyreCar, or Turo?",
        content: "With Rentid you keep more of your revenue. Hosts have full control over pricing, rental terms, and policies. Renters are verified using AI-powered screening tools through RentID. On-demand insurance through RentShield is tailored specifically for hosts. Rentid can operate as a direct booking system on the host’s website rather than through a marketplace.",
    },
    {
        title: "Do I need to own a rental company to use Rentid?",
        content: "Hosts do not need to own a formal rental company to use Rentid. Whether operating as a solo host with one car or managing a fleet of 100 or more, Rentid is designed to support hosts at every stage of their business.",
    },
    {
        title: "How do payments work?",
        content: "Payments are processed securely through Stripe, with funds deposited directly into the host’s account. Hosts can select daily, weekly, or monthly payout options.",  
    },
    {
        title: "Can I require a security deposit from renters?",
        content: "Rentid allows hosts to set custom security deposit amounts based on factors such as renter history, payment method, or vehicle type.",
    },
    {
        title: "How does Rentid verify renters?",
        content: "Rentid uses RentID, an AI-powered verification tool that checks a renter’s identity and driver’s license, validates personal auto insurance when required, and reviews rental and driving history to safeguard against unqualified rental bookings.",
    },
    {
        title: "Do I need my own rental insurance to use Rentid?",
        content: "Hosts do not need their own rental insurance to use Rentid. Rentid offers on-demand insurance through rentShield, allowing hosts to cover their vehicles only when they are rented instead of maintaining full-time fleet insurance.",
    },
    {
        title: "What happens if a renter damages my car?",
        content: "Rentid’s RentShield insurance provides coverage for eligible claims. The platform ensures renters meet strict verification criteria to minimize risk. Hosts can also set security deposits and rental terms to add an additional layer of protection.",
    },
    {
        title: "Does Rentid offer marketing support?",
        content: "Rentid provides marketing tools and guidance to help hosts attract renters. These tools include direct booking links, SEO-optimized pages, and automated renter communication.",
    },
    {
        title: "What if I need help managing my fleet?",
        content: "For larger fleets, Rentid offers dedicated account support, automated fleet tracking, and integrations with GPS telematics for real-time monitoring.",
    },
    {
        title: "How do I get started?",
        content: "Hosts can sign up for Rentid and take full control of their rental business by visiting our sign up page.",
    },
  ];

 ;


  const handleExpandClick = () => {
    if (isExpanded) {
      // Collapse all and show only the first two
      setExpanded([]);
    } else {
      // Expand all
     // setExpanded(accordionData.map((_, index) => `panel${index}`));
    }
    setIsExpanded(!isExpanded);
  };
  
  

 

  // Toggle accordion panels without collapsing others
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded ? [...prevExpanded, panel] : prevExpanded.filter(p => p !== panel)
    );
  };



  return (
    <section className='supportFaqMain'>
      <div className='container'>
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-12 col-sm-12">
            <div className="supportFaqLeft">
              <h6>SUPPORT</h6>
              <h2>FAQ for Hosts Transitioning <br/>from Marketplaces</h2>
              <p>If you're a <span>GetAround</span> or <span>HyreCar</span> host<br/> exploring Rentid, we know you have questions.</p>
              <p>Here are a few answers to help you make the switch and grow your rental business on your own terms.</p>
              {/* <a href="#" className="btn btnBlue">Join Waitlist</a> */}
              <BetaWaitlist
              showJoinWaitList={showWaitlist}
              onClose={() => setShowWaitlist(false)}
              onOpen={() => setShowWaitlist(true)}
              //flag={priority-waitlist}
              />
               <button onClick={() => setShowWaitlist(true)} className="btn btnBlue">
                Join Waitlist
                    </button> 
              {/* <JoinPriorityWaitlistBtn buttonClass="btn btnBlue" buttonText="Join Waitlist" /> */}
            </div>
          </div>
         
          <div className="col-lg-8 col-md-12 col-sm-12">
          
            <div className="supportFaqRight">

            <div className="supportFaqIcon">
            <div className="row align-items-center">
                <div className="col-md-4 col-4 faqIcon">
                  <img src="/img/faq.svg" alt="FAQ" className="img-fluid" />
                </div>
                <div className="col-md-8 col-8">
                  <p className="d-flex align-items-center justify-content-end m-0"> 
                  <Link onClick={handleExpandClick} className='expandimg expandBtn'>
                  <img
                    src={isExpanded ? "/img/collapse.svg" : "/img/expand-arrow.svg"}
                    alt="Expand arrow"
                    width="24"
                  />
                  {isExpanded ? 'Collapse' : 'Expand'}
                </Link>
                  </p>
                </div>
                </div>
                </div>



              <div className="headSupportFaq">
                <h2>FAQ</h2>
              </div>
              <div className="supportFaqRight_Inn">
              {accordionData.map((accordion, index) => (
                (isExpanded || index < 2) && (
                  <Box key={index} className="boxAccordian">
                    <Accordion className="headingAccordian"
                      expanded={expanded.includes(`panel${index}`)}
                      onChange={handleAccordionChange(`panel${index}`)}
                    >
                     <AccordionSummary
                  expandIcon={
                    expanded.includes(`panel${index}`) ? (
                      <Typography variant="h6">−</Typography>
                    ) : (
                      <Typography variant="h6">+</Typography>
                    )
                  }
                  aria-controls={`panel${index}-content`}
                >
                  <Typography>{accordion.title}</Typography>
                </AccordionSummary>

                    </Accordion>
                    {expanded.includes(`panel${index}`) && (
                      <Box className="summaryAccordian">
                        <Typography>{accordion.content}</Typography>
                      </Box>
                    )}
                  </Box>
                )
              ))}

              </div>
                <div className="load-more">
                     <a onClick={handleExpandClick}>  {isExpanded ? 'View Less' : 'View More'}  <img className='img-fluid'   src={isExpanded ? "img/load-more-less.png" : "/img/faq-elements.png"}  alt="rent id"/></a>

                    
                </div>
              

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportFaq;
